var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{on:{"changeMenu":_vm.toggleMenu}}),_c('Menu',{directives:[{name:"show",rawName:"v-show",value:(_vm.menuOpen),expression:"menuOpen"}],on:{"changeMenu":_vm.toggleMenu}}),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }